import { ReactComponent as Film } from "../assets/CommonAmenitiesImg/FilmSlate.svg";
import { ReactComponent as Karoake } from "../assets/CommonAmenitiesImg/MicrophoneStage.svg";
import { ReactComponent as Fire } from "../assets/CommonAmenitiesImg/Campfire.svg";
import { ReactComponent as YogaPerson } from "../assets/CommonAmenitiesImg/Person.svg";
import { ReactComponent as Villa } from "../assets/CommonAmenitiesImg/Farm.svg";
import { ReactComponent as CallBell } from "../assets/CommonAmenitiesImg/CallBell.svg";
import { ReactComponent as LetterP } from "../assets/CommonAmenitiesImg/LetterCircle.svg";
import { ReactComponent as SecurityCamera } from "../assets/CommonAmenitiesImg/SecurityCamera.svg";
import { ReactComponent as Racquet } from "../assets/CommonAmenitiesImg/Racquet.svg";

const commonAmenities = [
  { icon: <Film style={{ width: "20px", height: "20px", marginRight: "10px" }} />, text: "Under the Star Movie" },
  { icon: <Karoake style={{ width: "20px", height: "20px", marginRight: "10px" }} />, text: "Karaoke Entertainment" },
  { icon: <Fire style={{ width: "20px", height: "20px", marginRight: "10px" }} />, text: "Cozy Bonfire Nights" },
  { icon: <YogaPerson style={{ width: "20px", height: "20px", marginRight: "10px" }} />, text: "Yoga & Meditation Retreat" },
  { icon: <Villa style={{ width: "20px", height: "20px", marginRight: "10px" }} />, text: "Authentic Farm Experience" },
  { icon: <CallBell style={{ width: "20px", height: "20px", marginRight: "10px" }} />, text: "Personalised Concierge & Housekeeping" },
  { icon: <LetterP style={{ width: "20px", height: "20px", marginRight: "10px" }} />, text: "24/7 Free Parking" },
  { icon: <SecurityCamera style={{ width: "20px", height: "20px", marginRight: "10px" }} />, text: "CCTV Surveillance" },
  { icon: <Racquet style={{ width: "20px", height: "20px", marginRight: "10px" }} />, text: "Outdoor Play Area for kids" },
];

const accordionContent = [
  {
    title: "COMMON AMENITIES",
    points: commonAmenities,
  },
  {
    title: "SUITE RULES",
    points: [
      "⁠No shoes indoor",
      "No diving in the pool",
      "No pets allowed.",
      "No unregistered guest.",
      "Quiet hours from 10pm - 7am",
      "No smoking of any kind inside the suite",
      "No loud parties (respect our neighbours)",
      "No open flames or candles inside the suite",
      "⁠Guest is responsible for any damages to the property, decor, or furniture.",
    ],
  },
  {
    title: "CANCELLATION POLICY",
    points: [
      "Free Cancellation within 24 hours",
      "50% refund within 3 days",
      "No refund after 3 days",
      "Booking Fee is Non-Refundable",
      "Early Cancellation is Encouraged",
      "Flexible Rescheduling Option",
      "Refund to Original Payment Method",
      "Notify 24 Hours in Advance",
    ],
  },
];

const weekdayData = [
  "Tariff includes Lunch | Evening snacks | Dinner | Breakfast | Tea & Coffee",
  "Maximum occupancy in each suite is 4 adults",
  "₹2,000/- per child ≤ 10 years",
  "₹5,000/- extra adult 10+ years",
  "Stay Time : Check In: 02:00pm | Check Out: 11:00am"
];

const weekendData = [
  "Tariff includes Lunch | Evening snacks | Dinner | Breakfast | Tea & Coffee",
  "Maximum occupancy in each suite is 4 adults",
  "₹2,500/- per child ≤ 10 years",
  "₹6,000/- extra adult 10+ years",
  "Stay Time : Check In: 02:00pm | Check Out: 11:00am"
];

export { accordionContent, weekdayData, weekendData }